import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { _global_buttonStyles } from '../../../../../common/ObjectStructures/Trasnversal';
import { useBoolean } from '@fluentui/react-hooks';
import CTextArea from '../../../../Common/CTextArea';
import { useGetListGapAnalyzeComments } from '../../../../../hooks/services/sKPI/useOfGAP';
import PropTypes from 'prop-types';
import { addGapComment } from '../../../../../services/sKPI/gap.service';
import { __GapEventTypes, __MessageTypes } from '../../../../../common/Dictionaries';
import './style.css'
import MessageBox from '../../../../Common/Message/MessageBox';
import { showMessage } from '../../../../../common/Helpers';
import CTextAreaSimple from '../../../../Common/CTextAreaSimple';

const SidePanelAssistants = (props) => {
    const { t } = useTranslation();

    const { 
        inputParam_EditMode = null,
        inputParam_GapAnalyzeId = null,
        inputParam_GapRevisionId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_SetterChangedEntityProps = null
    } = props;   

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [objUserAssistantNames, setObjUserAssistantNames] = useState(null);
    const [txtUserAssistantNamesIsInValid, setTxtUserAssistantNamesIsInValid] = useState(null);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [objAssistantNamesList, setObjUserAssistantNamesList] = useState(null);
    useGetListGapAnalyzeComments(inputParam_GapAnalyzeId, inputParam_GapRevisionId, null, null, null, __GapEventTypes.GAP_REVISION_ASSISTANTS, objAssistantNamesList, setObjUserAssistantNamesList, inputParam_IsPanelOpen)

    const validateForm = (objNames) => {
        const valid = objNames !== "";

        setTxtUserAssistantNamesIsInValid(!valid)

        return valid;
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null)
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onAddUsersToBox = () => {
        const _isValidForm = validateForm(objUserAssistantNames);

        if (_isValidForm) {
            addGapComment(inputParam_GapAnalyzeId, inputParam_GapRevisionId, null, null, null, objUserAssistantNames, __GapEventTypes.GAP_REVISION_ASSISTANTS).then((response) => {
                if (response.data.succeeded) {
                    inputParam_SetterChangedEntityProps(prevState => ({
                        ...prevState,
                        listAssistants: (objUserAssistantNames !== "")
                    }))
    
                    onDismissPanel();

                    setObjUserAssistantNamesList(null);
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });

        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    };
    const onChangeAssistantsBox = (value) => {
        setObjUserAssistantNames(value);
    };
    

    const onRenderFooterContent = () => {
        return  <div>
                    {
                        inputParam_EditMode &&
                        <PrimaryButton onClick={ onAddUsersToBox } styles={ _global_buttonStyles }>{ t('data-lang-btn-save') }</PrimaryButton>
                    }
                    <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                </div>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-assistantslist') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col>
                    {
                        objAssistantNamesList && inputParam_EditMode &&
                        <CTextArea
                            labelText={ t('data-lang-lbl-body') }
                            controlValue={ objAssistantNamesList.length > 0 ? objAssistantNamesList.find(x => x.id === Math.max.apply(Math, objAssistantNamesList.map(function(o) { return o.id; }))).gapEventComment : "" }
                            setterControlValue={ onChangeAssistantsBox }
                            isInvalirControl={ txtUserAssistantNamesIsInValid }
                            hideToolbar={ true }
                            className={"demo-wrapper-h600"}
                        />
                    }
                    {
                        objAssistantNamesList && !inputParam_EditMode &&
                        <CTextAreaSimple editMode={false} classNameViewMode="demo-wrapper-h600" labelText={ t('data-lang-lbl-body') } controlValue={ objAssistantNamesList.length > 0 ? objAssistantNamesList.find(x => x.id === Math.max.apply(Math, objAssistantNamesList.map(function(o) { return o.id; }))).gapEventComment : "" } />
                    }
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-message">
                        <MessageBox  
                            inputParam_Width="96%" 
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelAssistants.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_GapRevisionId: PropTypes.number.isRequired,
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_SetterChangedEntityProps: PropTypes.func.isRequired,
};

export default SidePanelAssistants;